import { render, staticRenderFns } from "./x-radio-group.vue?vue&type=template&id=15186a9c&scoped=true&"
import script from "./x-radio-group.vue?vue&type=script&lang=js&"
export * from "./x-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./x-radio-group.vue?vue&type=style&index=0&id=15186a9c&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15186a9c",
  null
  
)

export default component.exports